import * as types from '../constants/actionTypes'

export const receiveApps = (apps) => ({ type: types.RECEIVE_APPS, apps })

export const updateCustomStyle = (appId, className, value) => {
  return {
    type: types.UPDATE_CUSTOM_STYLE,
    appId,
    className,
    value
  }
}



// WEBPACK FOOTER //
// ./src/actions/appsAC.js